// extracted by mini-css-extract-plugin
export var logo = "_hy-2";
export var logoWrapper = "_hy-1";
export var strip = "_hy-0";